import {defineError}from'./ErrorObject.js';var updateErrorInState = function updateErrorInState(dispatch, errorCode, inputAction) {
  var errorObject = defineError({
    errorCode: errorCode
  });
  dispatch(inputAction(errorObject));
};
var updateErrorInState$1 = updateErrorInState;export{updateErrorInState$1 as default};